import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TextVariant, TypographyNew } from "../typography/typography";
import React from "react";
import styled from "styled-components";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { IconDefinition } from "@fortawesome/pro-solid-svg-icons";

const Container = styled.div<{ center?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  gap: 10px;

  ${({ center }) =>
    center &&
    `
    text-align: center;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  `}
`;

const Circle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${(props) => props.theme.colors.grays5};
  width: 40px;
  height: 40px;
  border-radius: 64px;
  border: 12px solid ${(props) => props.theme.colors.grays9};
`;

const TextContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  color: ${(props) => props.theme.colors.grays3};
`;

interface EmptyStateProps {
  icon: IconDefinition;
  message: JSX.Element | string;
  className?: string;
  center?: boolean;
}

const EmptyState = (props: EmptyStateProps): JSX.Element => {
  return (
    <Container center={props.center} className={props.className}>
      <Circle>
        <FontAwesomeIcon
          icon={props.icon as IconProp}
          color={"white"}
          fontSize={"20px"}
        />
      </Circle>
      <TextContainer>
        <TypographyNew variant={TextVariant.body1}>
          {props.message}
        </TypographyNew>
      </TextContainer>
    </Container>
  );
};

export default EmptyState;
